import { render, staticRenderFns } from "./ProductAreaComponent.vue?vue&type=template&id=cbdac1bc&lang=pug&"
import script from "./ProductAreaComponent.vue?vue&type=script&lang=js&"
export * from "./ProductAreaComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports